export const DAY_HOURS = 24;

export const HOUR_MILLIS = 3600000;

export const DAY_MILLIS = 86400000;

export const MIN_VALID_MILLIS = 86340000;

export const SHORT_DAY_MIN_VALID_MILLIS = 82740000;

export const USER_SHORT_DAY_MIN_VALID_MILLIS = 3600000;

export const USER_MIN_VALID_MILLIS = 3600000;

export const PRELOAD_MODULES = true;



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/config/constants.ts